module.exports = __webpack_public_path__ + "img/ИФ-1(А)-022.84cd8276.png";